export const UPDATE_INVESTOR_TYPE_ATTEMPT = 'UPDATE_INVESTOR_TYPE_ATTEMPT';
export type UPDATE_INVESTOR_TYPE_ATTEMPT = typeof UPDATE_INVESTOR_TYPE_ATTEMPT;

export const UPDATE_INVESTOR_TYPE_SUCCESS = 'UPDATE_INVESTOR_TYPE_SUCCESS';
export type UPDATE_INVESTOR_TYPE_SUCCESS = typeof UPDATE_INVESTOR_TYPE_SUCCESS;

export const UPDATE_INVESTOR_TYPE_FAILURE = 'UPDATE_INVESTOR_TYPE_FAILURE';
export type UPDATE_INVESTOR_TYPE_FAILURE = typeof UPDATE_INVESTOR_TYPE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investor-type/update/Types.tsx